var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 96,
    height: 96,
    rx: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#E8F6FC",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.297 53.094c1.666.416 3.034 1.302 4.101 2.656C67.466 57.104 68 58.64 68 60.36v2.89c0 1.042-.365 1.927-1.094 2.656-.729.73-1.614 1.094-2.656 1.094h-32.5c-1.042 0-1.927-.365-2.656-1.094-.73-.729-1.094-1.614-1.094-2.656v-2.89c0-1.72.534-3.256 1.602-4.61 1.067-1.354 2.434-2.24 4.101-2.656l5.547-1.406c2.448 1.77 5.208 2.708 8.281 2.812 3.386.104 6.459-.833 9.219-2.812l5.547 1.406zM48 24c2.24 0 4.323.56 6.25 1.68a12.411 12.411 0 0 1 4.57 4.57 12.227 12.227 0 0 1 1.68 6.25c0 2.24-.56 4.323-1.68 6.25a12.411 12.411 0 0 1-4.57 4.57A12.227 12.227 0 0 1 48 49c-2.24 0-4.323-.56-6.25-1.68a12.411 12.411 0 0 1-4.57-4.57 12.227 12.227 0 0 1-1.68-6.25c0-2.24.56-4.323 1.68-6.25a12.411 12.411 0 0 1 4.57-4.57A12.227 12.227 0 0 1 48 24z",
    stroke: "#767676",
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.e1ec9127fc485c3bbd8e6c762abc59c3.svg";
export { ForwardRef as ReactComponent };